<template>
  <zpa-column :height="!!height ? 'auto' : undefined">
    <slot name="fab"></slot>
    <div style="margin-left: auto;" v-if="$slots.fab2">
      <slot name="fab2"></slot>
    </div>

    <zpa-column ref="TableContainer" :height="!!height ? 'auto' : undefined" style="flex: auto;">
      <Table
        v-if="isShow"
        width="100%"
        :height="tableHeight"
        size="small"
        :loading="isLoading"
        :stripe="stripe"
        :border="border"
        :highlight-row="highlightRow"
        :disabled-hover="disabledHover"
        :filteredValue="filteredValue"
        :columns="tableColumns"
        :data="data"
        :span-method="colspanMethod"
        @on-selection-change="selectionChange"
        @on-sort-change="changeSort"
        @on-current-change="changeCurrent"
        @on-row-dblclick="dblclickRow"
        @on-row-click="selectRow"
        :row-class-name="rowClassName"
        :show-summary="showSummary"
      >
      </Table>
    </zpa-column>
    <div v-if="page.totalRows!=0" style="line-height:24px">
      <zpa-row end height="auto" v-if="!!page && !isHidePage">
        <span>共{{page.totalRows}}条记录</span>
        <Page
          :total="page.totalRows"
          :current="page.pageNo"
          :pageSize="page.pageSize"
          size="small"
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        />
      </zpa-row> </div>
    <slot name="Drawer"></slot>
  </zpa-column>
</template>

<script>
import _ from 'lodash'

const defaultSort = {
  sort: 'updateDate',
  order: 'desc',
}

const defaultPage = {
  pageNo: 1,
  pageSize: 10,
}

export default {
  name: 'zpaTable',
  inject: ['menuCode'],
  data() {
    return {
      isShow: true,

      isLoading: false,

      tableHeight: 0,

      params: {},

      operatorWidth: 140,

      page: Object.assign({}, defaultPage),

      sort: Object.assign({}, defaultSort),
      spanArr: [],
    }
  },

  props: {
    data: {type: Array, default: () => { return [] }},
    height: [Number, String],

    idField: String,

    index: Boolean,

    checkbox: Boolean,

    columns: Array,

    pageNo: Number,

    pageSize: Number,

    sortKey: String,

    sortOrder: {
      validate(val) {
        return ['asc', 'desc'].includes(val)
      },

      type: String,
    },

    query: {
      type: Function,
      require: true,
    },

    operWidth: Number,

    isHidePage: Boolean,

    filteredValue: Array,

    border: {
      type: Boolean,
      default: false,
    },
    disabledHover: {
      type: Boolean,
      default: false,
    },
    highlightRow: {
      type: Boolean,
      default: true,
    },
    firstRowHighLight: { // 第一行是否默认高亮
      type: Boolean,
      default: true,
    },

    stripe: {
      type: Boolean,
      default: true,
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    needMerge: {// 是否需要合并table中的单元格
      type: Boolean,
      default: false
    },
    keyId: { // 合并依据：相同的 可以
      type: String,
      default: ''
    },
    columnIndexs: { // 需要合并的列
      type: Array,
      default: () => {
        return []
      }
    },
    manualMarges: { // 手动合并,   {key:{index:{rowspan: 1,colspan: 2}  }}
      type: Object,
      default: null
    },
    rowClassName: {
      type: Function,
      default: () => {
        return ''
      }
    },
  },

  computed: {
    tableColumns() {
      let columns = []
      let arr = null
      if (this.menuCode) {
        let str = localStorage.getItem(this.menuCode)
        if (str) {
          arr = JSON.parse(str)
          arr = arr.filter(p => p.isShow === true)
        }
      }
      if (arr) {
        columns = [].concat(arr)
      } else {
        columns = [].concat(this.columns)
      }
      const hasFixed = columns.some(c => c.fixed === 'left')

      columns.forEach(c => {
        c.ellipsis = c.ellipsis !== false
        c.tooltip = c.tooltip !== false

        const format = c.format
        const node = this.$scopedSlots[c.key]
        if (node) {
          c.render = (h, params) => {
            params.value = params.row[c.key]
            return node(params)
          }
        } else if (format) {
          c.render = (h, params) => {
            params.value = params.row[c.key]
            return h('span', [format(params)])
          }
        }
      })

      // 添加序号
      if (this.index) {
        const col = {type: 'index', width: 80, align: 'center', title: '序号'}
        if (hasFixed) col.fixed = 'left'
        columns.unshift(col)
      }

      // 添加checkbox
      if (this.checkbox) {
        const col = {type: 'selection', width: 60, align: 'center'}
        if (hasFixed) col.fixed = 'left'
        columns.unshift(col)
      }

      const {default: $operators} = this.$scopedSlots

      if ($operators) {
        columns.push({
          key: '$operators',
          title: '操作',
          align: 'center',
          width: (this.operWidth || this.operatorWidth),
          fixed: 'right',
          render: (h, params) => {
            return h('div', {
              'class': {
                'column_operator': true,
              },
              style: {
                whiteSpace: 'nowrap',
                display: 'inline-block',
              },
            }, [$operators({
              ...params
            })])
          },
        })
      }

      return columns
    }
  },

  methods: {
    checkRow(data = [], flag) {
      if (!data.length || !this.idField) return false

      this.data.filter(d => data.includes(d[this.idField]))
        .forEach(v => {
          v._checked = !flag // 由于iView的bug，当直接操作列表复选框时，_checked是不会更改的，所以强制修改一次来触发数据绑定
          v._checked = flag
        })
    },

    async load({params, page, sort} = {}) {
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
      })
      this.data = []
      this.isLoading = true

      // // 如果参数(存在非undefined)改变，页数改为1
      // if (!_.isEqual(params, this.params)) {
      //   this.page.pageNo = 1
      //   page.pageNo = 1
      // }
      // this.params = params
      const field = this.field
      page = page || Object.assign({}, this.page, {pageNo: 1})
      params = params || this.params
      sort = sort || this.sort
      this.params = params

      // TODO data 和 page 的获取改为可配置
      const result = await this.query({params, page, sort, field})
      const objList = result.objList || result
      const pageDesc = result.pageDesc

      if (objList && objList.length && this.$el.querySelector('.column_operator')) {
        this.$nextTick(() => {
          this.operatorWidth = this.$el.querySelector('.column_operator').clientWidth + 40
        })
      }

      this.page = pageDesc || this.page
      this.data = objList
      if (this.data && this.data.length) {
        const row = this.data[0]
        if (this.firstRowHighLight) {
          row._highlight = true
        }

        this.changeCurrent(row)
      }

      this.isLoading = false
    },
    async load1({params = this.params, page = this.page, sort = this.sort} = {}) {
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
      })
      this.data = []
      this.isLoading = true

      // 如果参数改变，页数改为1
      if (!_.isEqual(params, this.params)) {
        this.page.pageNo = 1
        page.pageNo = 1
      }
      this.params = params

      // TODO data 和 page 的获取改为可配置
      const result = await this.query({params, page, sort})
      const objList = result.objList || result
      const pageDesc = result.pageDesc

      if (objList && objList.length && this.$el.querySelector('.column_operator')) {
        this.$nextTick(() => {
          this.operatorWidth = this.$el.querySelector('.column_operator').clientWidth + 40
        })
      }

      this.page = pageDesc || this.page
      this.data = objList
      this.tableHeight = 41 * (this.data.length + 1)
      if (this.data && this.data.length) {
        const row = this.data[0]
        row._highlight = true
        this.changeCurrent(row)
      }

      this.isLoading = false
    },

    selectionChange(data) {
      this.$emit('onSelectionChange', data)
    },

    selectRow(now, index) {
      this.$emit('onSelectRow', now, index)
    },

    appendRow(row) {
      this.data.push(row)
    },

    insertRow(row, index) {
      if (index === undefined) {
        return this.appendRow(row)
      }

      if (index === 0) {
        return this.data.unshift(row)
      }

      // 在新位置插入数据
      this.data.splice(index - 1, 0, row)
    },

    updateRow(row, index) {
      this.$set(this.data, index, row)
    },

    deleteRow(index) {
      this.data.splice(index, 1)
    },

    changeSort({key, order, column}) {
      this.sort = {
        sort: column.sortKey || key,
        order,
      }

      // 默认排序
      if (!order || order === 'normal') {
        this.sort = Object.assign({}, defaultSort)
      }
      return this.load()
    },

    changePage(pageNo) {
      this.page.pageNo = pageNo
      return this.load({page: this.page})
    },

    changePageSize(pageSize) {
      this.page.pageSize = pageSize
      return this.load({page: this.page})
    },

    changeCurrent(now, old) {
      this.$emit('on-selected-change', now, old)
    },

    dblclickRow(now, index) {
      this.$emit('on-dblclick-row', now, index)
    },

    resize() {
      this.tableHeight = this.height || this.$refs['TableContainer'].$el.clientHeight - 16
    },

    initSort(sort, order) {
      this.sort.sort = sort;
      if (order === '') {
        this.sort.order = 'asc';
      } else {
        this.sort.order = order;
      }
    },

    // 处理table单元格合并
    colspanMethod: function({ row, column, rowIndex, columnIndex }) {
      // row:行对象，带有一行所有数据，column:列对象
      // rowIndex:行索引，columnIndex:列索引
      // 加载表格时从（0，0）开始，（0，1）···（1，0）,(1,1)···依次获取数据

      if (this.needMerge) {
        if (this.manualMarges) {
          let temp = this.manualMarges[row[this.keyId]]
          if (temp && temp[columnIndex]) {
            return temp[columnIndex]
          }
        }

        if (this.columnIndexs.indexOf(columnIndex) !== -1) {
          // 每次走到第3列时给单元格加上rowspan和colspan属性
          const _row = this.spanArr[rowIndex]// 从处理完的数组里获取
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col // 相当于给给表格加上rowspan,colspan属性
          }
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1 // 相当于给给表格加上rowspan,colspan属性
        }
      }
    },
    // 由于数据是动态的，所以页面加载时需要调用下面的方法，根据后台数据处理以知道要合并的行/列
    // 得到的spanArr数组表示某一行所需要合并的列数
    getSpanArr: function(data) {
      this.spanArr = []// 定义在vue的data中
      if (data == null) {
        return
      }
      for (let i = 0; i < data.length; i++) {
        if (i === 0 || data[i][this.keyId] === '' || typeof (data[i][this.keyId]) === undefined || data[i][this.keyId] === null) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          if (data[i][this.keyId] === data[i - 1][this.keyId]) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
  },

  mounted() {
    this.page.pageNo = this.pageNo || this.page.pageNo
    this.page.pageSize = this.pageSize || this.page.pageSize

    this.$root.$on('resize', this.resize)

    this.$nextTick(() => this.resize())
  },

  destroyed() {
    this.$root.$off('resize', this.resize)
  },

  created() {
    this.getSpanArr(this.tableDatas)
  },
  watch: {
    tableHeight(newValue, oldValue) {
      if (newValue > oldValue) {
        this.$emit('heightBigger', newValue)
      }
    },
    // 监听tableDatas 当 tableDatas 变化时触发
    data: {
      immediate: true, // 这句重要
      handler(val) {
        this.getSpanArr(this.data)
      }
    }
  }
}
</script>
<style>
.top-btns button:not(:first-child) {
  margin-left: 15px;
}
</style>
